import { css } from 'styled-components';

/**
 * Bottom clearance the iOS 26 fleet-app floating tab bar needs. Resolves to the
 * CSS custom property published by `useNativeTabbarSpace`; falls back to `0px`
 * outside the native app.
 */
export const NATIVE_TABBAR_SPACE = 'var(--fleet-native-tabbar-space, 0px)';

/**
 * Appends a flex-shrink:0 spacer to a **scrollable flex column** so its last
 * child clears the floating native tab bar. The container must be
 * `display: flex; flex-direction: column; overflow-y: auto`.
 */
export const nativeTabbarSpaceSpacer = css`
  &::after {
    content: '';
    display: block;
    flex-shrink: 0;
    height: ${NATIVE_TABBAR_SPACE};
  }
`;

/**
 * Adds bottom padding equal to the native tab bar clearance. Use on top-level
 * page containers that scroll with the document (no inner flex spacer needed).
 */
export const nativeTabbarSpacePadding = css`
  padding-bottom: ${NATIVE_TABBAR_SPACE};
`;
